import React, { Component } from 'react'
import Dialog from "./../../../../../components/dialog-base"
import './styles.scss'
import connector from 'src/decorators/connector'
import { IStoresMap } from 'src/types'


interface IFloorsNumbersProps {
    onClose: () => void
    item: {
        id: string,
        img: string,
        name: string,
        price: number,
        size: string,
        type: number
    }
}

class FloorsNumbersPopUp extends React.Component<IFloorsNumbersProps & ReturnType<typeof storesToProps>> {
    public state = {
        startFloor: 1,
        endFloor: 1,
        count: 1,
        plates: [{ number: 1, count: 1 }]
    }


    public minusStartFloor = () => {
        if (this.state.startFloor > 2) {
            this.setState({ startFloor: this.state.startFloor - 1 })
            this.state.plates.unshift({ number: this.state.startFloor - 1, count: this.state.count })

        }
    }
    public minusEndFloor = () => {
        if (this.state.endFloor > 2 && this.state.endFloor > this.state.startFloor) {
            this.setState({ endFloor: this.state.endFloor - 1 })
            this.state.plates.pop()
        }
    }
    public minusCountFloor = () => {
        if (this.state.count > 1) {
            this.setState({ count: this.state.count - 1 })
            let newPlates = [] as any
            this.state.plates.forEach((item, index) => { newPlates[index] = { number: item.number, count: this.state.count - 1 } })
            this.setState({ plates: newPlates })
        }
    }
    public plusStartFloor = () => {
        if (this.state.endFloor > this.state.startFloor) {
            this.setState({ startFloor: this.state.startFloor + 1 })
            this.state.plates.shift()
        } else {
            this.setState({ startFloor: this.state.startFloor + 1, endFloor:  this.state.startFloor + 1})
            this.state.plates.shift()
            this.state.plates.push({ number: this.state.endFloor + 1, count: this.state.count })
        }
    }
    public plusEndFloor = () => {
        this.setState({ endFloor: this.state.endFloor + 1 })
        this.state.plates.push({ number: this.state.endFloor + 1, count: this.state.count })
    }
    public plusCountFloor = () => {
        this.setState({ count: this.state.count + 1 })
        let newPlates = [] as any
        this.state.plates.forEach((item, index) => { newPlates[index] = { number: item.number, count: this.state.count + 1 } })
        this.setState({ plates: newPlates })
    }

    public changeNumberCount = (number: number, count: number) => {
        let newPlates = this.state.plates
        if (newPlates[number].count > 0 || count > newPlates[number].count){
            newPlates[number].count = count
            this.setState({ plates: newPlates })
        } 
    }

    public get allCount() {
        let count = 0
        this.state.plates.forEach(item => count += item.count)
        return count
    }

    public onAddProduct = () => {
        const { addProduct } = this.props.busket
        let descpition = ""
        this.state.plates.forEach(item =>{
            descpition = descpition + `этаж ${item.number} (${item.count}), ` 
        })
        descpition = descpition.substring(0, descpition.length - 2)
        addProduct(this.props.item, this.allCount, this.state.startFloor, this.state.endFloor, descpition)
        this.props.onClose()
    }


    render() {
        const { startFloor, endFloor, count } = this.state

        return <Dialog onClose={this.props.onClose}>
            <div className="floors_number_container">
                <img className="dialogClose" onClick={this.props.onClose} src="/local/templates/sign_plus/images/close.svg" alt="" />
                <div className="dialogContaine__inner">
                    <div className="title">
                        {this.props.item.name}
                </div>
                    <div className="top_block">
                        <img className={this.props.item.type === 39 ? "big_picture" : "small_picture"} src={this.props.item.img} />
                        <div className="numbers">
                            Этажи с <div className='swither_container'>
                                <div className="minus" onClick={this.minusStartFloor}>-</div>
                                <div className="count">{startFloor}</div>
                                <div className="plus" onClick={this.plusStartFloor}>+</div>
                            </div> по <div className="minus" onClick={this.minusEndFloor}>-</div>
                            <div className="count">{endFloor}</div>
                            <div className="plus" onClick={this.plusEndFloor}>+</div>
                        </div>
                        <div className="counts">
                            Количество комплектов
                        <div className="minus" onClick={this.minusCountFloor}>-</div>
                            <div className="count">{count}</div>
                            <div className="plus" onClick={this.plusCountFloor}>+</div>
                        </div>
                    </div>
                    <div className="middle_block">
                        {
                            this.state.plates.map((item, index) => <div key={index} className={`plate ${item.count === 0 ? 'disable' : ''}`}>
                                <div className={`number`}>
                                    {item.count > 1 && <div className="count">{ item.count}</div>}
                                    <div className="number">
                                        <div className="minus" onClick={() => this.changeNumberCount(index, item.count - 1)}>-</div>
                                        <div className="floor_number">{item.number}</div> 
                                        <div className="floor_label">этаж</div>
                                    <div className="plus" onClick={() => this.changeNumberCount(index, item.count + 1)}>+</div>
                                    </div>
                                </div>
                            </div>)
                        }
                    </div>
                    <div className="bottom_block">
                        <div className="price">{this.props.item.price} руб/шт</div>
                        <div className="count">{this.allCount} шт</div>
                        <div className="allPrice">{this.allCount * this.props.item.price} руб</div>
                    </div>
                    <div className="inBusker" onClick={this.onAddProduct}>В корзину</div>
                </div>

            </div>
        </Dialog>
    }
}

const storesToProps = ({ store }: IStoresMap, _nextProps: any ) => ({
    busket: store.BusketStore
})

export default connector(storesToProps)(FloorsNumbersPopUp)
